@import '../../../../../../constants/spacing.module.less';

.prepareProductsBody {
  justify-content: flex-start;
}

.stepCard {
  padding: @space-8;
  text-align: left;
  &:not(:last-child) {
    border-bottom: 1px solid var(--grey-300);
  }
}

.stepHeader {
  margin-bottom: @space-8;
}

.stepDescription {
  color: var(--grey-700);
  line-height: 1.5;
}

.linkContainer {
  margin-top: @space-16;
  align-items: center;
}

.downloadIcon {
  margin-left: @space-8;
  width: @space-12;
  height: @space-12;
}

.checkboxContainer {
  padding-bottom: @space-16;
  margin-top: @space-16;
}

.linkButton {
  font-size: 14px;
}
